<template>
  <ElevatorDrawer :visible.sync="visible" size="1230px" :destroy-on-close="true" @close="closeHandle">
    <span slot="title">
      <span style="color: #000">快团团发布</span>
      <span style="color: coral;font-size: 12px; margin-left: 10px;"> <i class="el-icon-warning"></i> 商品发布成功后请务必及时去平台检测商品信息，以平台信息为准。</span>
    </span>
    <InfoForm ref="baseForm" :initBaseItemIds="opts.baseItemIds" :isDistributor="opts.isDistributor" v-if="visible" />
    <span slot="footer">
      <el-button type="primary" @click="handleSave" :loading="saving" :disabled="saving">发布</el-button>
    </span>
  </ElevatorDrawer>
</template>

<script>
import InfoForm from '../components/KttForm/index.vue';
import ElevatorDrawer from '@components/common/ElevatorDrawer.vue';
import { editKttInfo } from '@/servers/prod/center/ktt.js';

export default {
  components: {
    InfoForm,
    ElevatorDrawer,
  },
  data() {
    return {
      visible: false,
      opts: {},
      saving: false,
    };
  },
  methods: {
    method_open(opts) {
      this.visible = true;
      this.opts = opts;
    },
    closeHandle() {
      this.visible = false;
    },
    async handleSave() {
      if (this.saving) return;
      this.saving = true;
      try {
        // 这里可以调用 InfoForm 的方法获取表单数据
        const data = await this.$refs.baseForm.method_getFormData();
        if (!data) return;
        const res = await editKttInfo(data.products);
        if (res) {
          const itemIds = data.products.map(item => item.baseItemId);
          this.opts.okFn && this.opts.okFn(data.groupData, itemIds);
          this.closeHandle();
        }
      } catch (e) {
        this.$message.error((e && e.message) || '发布失败，请稍后重试');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>